
import { useState, useEffect, useRef } from "react";
import ProductHeader from "../../Components/ProductsPages/ProductHeader";
import ProductsHeroSection from "../../Components/ProductsPages/ProductsHeroSection";
import ProductFooter from "../../Components/ProductsPages/ProductFooter";
import RequestDemo from "../../Components/ProductsPages/RequestDemo";
import QSleeveImage from "../../Images/videothumbnail.jpg";
import BackgroundGradient from "../../Images/BackgroundGradient.png";
import BackgroundGradientSmall from "../../Images/BackgroundGradientSmall.png";
import VideoComponent from "../../Components/VideoComponent";
import { KeyFeatures } from "../../Components/KeyFeatures";
import { ProductTable, IOTable } from "../../Components/ProductsPages/ProductTable";
import QMEMORY1 from "../../../src/Images/Boxes/QUANTUM_MEMORY_P1.png";
import QMEMORY2 from "../../../src/Images/Boxes/QUANTUM_MEMORY_P2.png";
import { currentSite } from "../../Config/siteConfig";

export default function QMemory() {
  const requestDemoRef = useRef(null);
  const architectureRef = useRef(null);

  const [backgroundImage, setBackgroundImage] = useState(``);

  useEffect(() => {
    const updateBackgroundImage = () => {
      if (window.innerWidth < 640) {
        setBackgroundImage(`url(${BackgroundGradientSmall})`);
      } else {
        setBackgroundImage(`url(${BackgroundGradient})`);
      }
    };

    updateBackgroundImage();

    window.addEventListener("resize", updateBackgroundImage);

    return () => window.removeEventListener("resize", updateBackgroundImage);
  }, []);

  const scrollToRequestDemo = () => {
    requestDemoRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToArchitecture = () => {
    architectureRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const keyFeatures = [
    "Photonic Polarisation Pulse Storage",
    "Room Temperature Operation",
    "Long Storage Time",
    "Long-lasting Alignment Free Operation",
    "Resistant to Electromagnetic Noise",
    "Upgradable to Single Photon Level Quantum Memory",
    "Intuitive Software Interface",
    "Room Temperature Operation",
    "Intuitive Software Interface",
    "Pulse Shaping Control",
    "Long-lasting Alignment Free Operation",
  ];

  const specifications1 = [

     ["Parameter", "Unit", "Min.", "Max.", "Typical"],
              ["Operating Wavelength", "nm", "-", "-", "794.8 ± 0.1"],
              ["Pulse Duration", "µs", "0.2", "10", "4"],
              ["Storage Time", "µs", "0.2", "20", "8"],
              ["Efficiency", "%", "-", "-", "10"],
              ["Probe Input Power", "mW", "-", "-", "2"],
              ["Control Input Power", "mW", "-", "-", "5"],
              ["Operating Temperature of Vapour Cell", "°C", "30", "110", "55"],
              ["Ambient Temperature", "°C", "10", "45", "20"],
              ["Warm-up Time", "min", "-", "-", "15"],
              ["Dimensions", "mm³", "-", "-", "432 × 482 × 105"],
              ["Weight", "kg", "-", "-", "15"],
    
  ];

  const specifications2 = [
    ["Parameter", "Unit", "Min.", "Max.", "Typical"],
    ["Operating Wavelength", "nm", "-", "-", "794.8 ± 0.1"],
    ["Linewidth", "MHz", "-", "-", "<6"],
    ["Continuous Adjustment Free Duration", "hrs", "-", "-", "10"],
    ["Control Laser Output Power", "mW", "-", "-", "10"],
    ["Probe Laser Output Power", "mW", "-", "-", "10"],
    ["Warm-up Time", "min", "-", "-", "30"],
    ["Ambient Temperature", "°C", "10", "45", "20"],
    ["Dimensions", "mm³", "-", "-", "432 × 482 × 105"],
    ["Weight", "kg", "-", "-", "12"],
    ["Power Consumption", "W", "180", "-", "180"],]
  
  const inputOutputs1 = [  ["Inputs", "Outputs"],
          ["Optical Inputs", "3 X (FC/APC,PMF)"],
          ["Analog Outputs", "4 X BNC"],]

  const inputOutputs2 = [ ["Inputs", "Outputs" ],
              ["Optical Outputs", "3 X (FC-APC,PMF)" ],
              ["Analog Inputs", "1 X SMA" ],
              ["Analog Outputs", "1 X SMA" ],
              ["Interface", "Ethernet and USB" ]]

  return (
    <div className="w-full  flex flex-col gap-0 items-center justify-center bg-primary7">
      <div
        className="w-full bg-primary7 width flex flex-col gap-0 items-center justify-center bg-contain bg-repeat"
        style={{ backgroundImage: backgroundImage }}
      >
        <ProductHeader scrollToRequestDemo={scrollToRequestDemo} />
        <div className="w-full h-[25rem] ">
          <ProductsHeroSection
            title1="High-Performance Quantum"
            title2="Storage & Control System"
            content="A complete platform for photonic quantum memory experiments with electromagnetic shielding, flexible pulse shaping, and seamless software integration. "
            scrollToArchitecture={scrollToArchitecture}
          />
        </div>

        <div className="w-full bg-primary7 width md:px-10  flex flex-col items-center justify-center pb-10 gap-1">
          <div className="w-[90%] text-center md:text-left text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem] font-RobotoBold text-white leading-tight px-3 ">
            <span className="wordGradient">
              Quantum Memory Experimentation Kit
            </span>
          </div>

          <div className="w-[90%] h-full   grid grid-cols-1 xl:grid-cols-2  place-items-start gap-10 lg:gap-44 p-3">
            <div className="w-full  flex flex-col items-center justify-center  gap-1">
              <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
                The first module of the Quantum Memory Experimentation Kit
                showcases the storage and retrieval processes of Photonic
                Polarization Pulses in a Rubidium (Rb)-based hot vapor ensemble.
                It facilitates a range of experiments related to quantum storage
                and characterization. The design of the quantum storage unit
                includes shielding to protect it from external magnetic fields.
              </div>

              <div className="w-full sm:px-10 flex items-start justify-start">
                <KeyFeatures features={keyFeatures.slice(0, 7)} />
              </div>
            </div>

            <div className="w-full  flex flex-col items-center justify-center  gap-1">
              <div className="w-full  flex flex-col items-start justify-start ">
                <img
                  src={QMEMORY1}
                  alt="QMEMORY1"
                  className="w-full h-full object-contain rounded-lg md:rounded-2xl"
                />
                <p className="w-full lg:max-w-[600px] text-center text-xs italic text-white/70 mt-2">
                  Figure 1: Quantum Memory
                </p>
              </div>
            </div>
          </div>
          <div className="w-[90%] h-full  grid grid-cols-1 xl:grid-cols-2  place-items-start gap-20 ">
            <ProductTable title="Specifications" data={specifications1} />
            <IOTable title="Input/Outputs" data={inputOutputs1} />
          </div>
        </div>
        <div className="w-full bg-primary7 width md:px-10  flex flex-col items-center justify-center pb-10 gap-1">
          <div className="w-[90%] text-center md:text-left text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem] font-RobotoBold text-white leading-tight px-3 ">
            <span className="wordGradient">Input Laser Control System</span>
          </div>

          <div className="w-[90%] h-full   grid grid-cols-1 xl:grid-cols-2  place-items-start gap-10 lg:gap-44 p-3">
            <div className="w-full  flex flex-col items-center justify-center  gap-1">
              <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
                The second module of the Quantum Memory Kit, Input Laser Control
                System, is a versatile solution for precise Signal Modulation
                and Control. This system is designed to generate two laser
                output signals separated by a 6.8 GHz frequency difference for
                Rubidium-based Quantum Memory operations. It is capable of
                generating laser pulse sequences with flexible parameter
                programming through an intuitive GUI. The technical parameters
                can be adjusted to suit various experimental setups including
                three-level systems such as EIT, CPT, and cold atom-based
                applications.
              </div>

              <div className="w-full sm:px-10 flex items-start justify-start">
                <KeyFeatures features={keyFeatures.slice(7, 12)} />
              </div>
            </div>

            <div className="w-full  flex flex-col items-center justify-center  gap-1">
              <div className="w-full  flex flex-col items-start justify-start ">
                <img
                  src={QMEMORY2}
                  alt="QMEMORY1"
                  className="w-full h-full object-contain rounded-lg md:rounded-2xl"
                />
                <p className="w-full lg:max-w-[600px] text-center text-xs italic text-white/70 mt-2">
                  Figure 2: Input Laser Control System
                </p>
              </div>
            </div>
          </div>
          <div className="w-[90%] h-full  grid grid-cols-1 xl:grid-cols-2  place-items-start gap-20 ">
            <ProductTable title="Specifications" data={specifications2} />
            <IOTable title="Input/Outputs" data={inputOutputs2} />
          </div>
        </div>
        {currentSite === "site2" && (
          <VideoComponent
            video={"https://thequantum.ai/videos/QuantumMemoryVideo.mp4"}
          />
        )}
        {currentSite === "site1" && (
          <VideoComponent
            video={"https://qulabs.ai/videos/QuantumMemoryVideo.mp4"}
          />
        )}
        <div
          className="w-full bg-primary7 width flex flex-col items-center justify-center gap-2 "
          ref={requestDemoRef}
        >
          <RequestDemo />
        </div>

        <ProductFooter />
      </div>
    </div>
  );
}

